import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BlogType } from './blog.type';

export type SelectedBlog = (BlogType & { bound: DOMRect }) | undefined;

export type BlogState = {
    selectedBlog: SelectedBlog;
    closeDetail: boolean;
    blogList: Array<BlogType>;
};
export const initialState: BlogState = {
    selectedBlog: undefined,
    closeDetail: false,
    blogList: []
};

const blogSlice = createSlice({
    name: 'blogSlice',
    initialState,
    reducers: {
        setSelectedBlog: (state, { payload: selectedBlog }: PayloadAction<SelectedBlog>) => {
            state.selectedBlog = selectedBlog;
            state.closeDetail = true;
        },
        unSelectedBlog: (state) => {
            state.selectedBlog = undefined;
        },
        toggleDetail: (state, { payload: closeDetail }: PayloadAction<boolean>) => {
            state.closeDetail = closeDetail;
        },
        setBlog: (state, { payload: blogList }: PayloadAction<Array<BlogType>>) => {
            state.blogList = blogList;
        },
        appendBlog: (state, { payload: blogList }: PayloadAction<Array<BlogType>>) => {
            const newBlog = blogList.map((blog, index) => ({
                ...blog,
                id: `${state.blogList.length + index}`
            }));
            state.blogList = [...state.blogList, ...newBlog];
        }
    }
});

export const blogReducer = blogSlice.reducer;
export const {
    setSelectedBlog,
    toggleDetail,
    setBlog,
    appendBlog,
    unSelectedBlog
} = blogSlice.actions;
